var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNublado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 31,
    viewBox: "0 0 56 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5772 13.9721C51.5585 13.9721 51.5406 13.9777 51.5219 13.9777C51.8707 13.173 52.066 12.2836 52.066 11.3481C52.066 7.68186 49.0937 4.70836 45.4266 4.70836C44.1308 4.70836 42.9254 5.08482 41.9035 5.72867C40.5213 2.36801 37.2186 0 33.3606 0C28.2586 0 24.1225 4.13543 24.1225 9.23942C24.1225 9.62413 24.1535 10.0006 24.1995 10.3744C24.1736 10.3744 24.1484 10.3717 24.1225 10.3717C20.7019 10.3717 17.9286 13.1431 17.9286 16.564C17.9286 19.9849 20.7019 22.759 24.1225 22.759H51.5772C54.0034 22.759 55.97 20.7922 55.97 18.3671C55.97 15.9393 54.0034 13.9725 51.5772 13.9725V13.9721Z",
    fill: "#BED7F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5701 19.7525C40.5472 19.7525 40.5262 19.7578 40.5032 19.7578C40.9238 18.7839 41.1598 17.7118 41.1598 16.5854C41.1598 12.1634 37.5757 8.58171 33.1546 8.58171C31.5921 8.58171 30.1389 9.03466 28.9067 9.8092C27.2401 5.75829 23.2583 2.9021 18.6062 2.9021C12.4547 2.9021 7.46798 7.89146 7.46798 14.043C7.46798 14.5066 7.50568 14.9623 7.56099 15.4123C7.52955 15.4123 7.49943 15.4067 7.46798 15.4067C3.34371 15.4067 0 18.7511 0 22.8754C0 26.9997 3.34349 30.3434 7.46798 30.3434H40.5701C43.4952 30.3434 45.8666 27.9722 45.8666 25.0471C45.8666 22.1223 43.4952 19.7522 40.5701 19.7522V19.7525Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNublado);
export default __webpack_public_path__ + "static/media/nublado.616ba247304f0c0a4599a979054f7ed4.svg";
export { ForwardRef as ReactComponent };